export class Constants {

    public static API = {
      url: `https://detops.hugheson.com/`
    };
}
